import React, { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { Card, Button } from './ds';
import { consentService } from '../services';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

// Blocking-Gate (AUD-14): Vor dem ersten Assessment muss der Nutzer aktiv bestätigen,
// dass Audicio eine reine Self-Assessment-Plattform ist. Opt-in (Checkbox startet leer),
// der Disclaimer-Text steht sichtbar direkt über der Checkbox. Erst nach protokollierter
// Zustimmung ruft die Komponente onAccepted() auf.
const SelfAssessmentDisclaimerGate = ({ disclaimer, onAccepted }) => {
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    if (!checked || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await consentService.acceptSelfAssessmentDisclaimer();
      onAccepted();
    } catch {
      setError('Ihre Bestätigung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
      setSubmitting(false);
    }
  };

  return (
    <Card padding={0} style={{ maxWidth: 560, margin: '0 auto' }}>
      <div style={{ padding: '40px 40px 36px', fontFamily: FONT }}>
        <div style={{
          width: 56, height: 56, borderRadius: 14,
          background: 'var(--warn-50, #FDF6EC)', color: 'var(--warn-700, #A15C07)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 0 20px',
        }}>
          <ShieldAlert width={28} height={28} />
        </div>

        <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 700, color: '#101623' }}>
          Bevor Sie starten
        </h2>
        <p style={{ color: '#667085', fontSize: 14, margin: '0 0 20px', lineHeight: 1.6 }}>
          Bitte lesen und bestätigen Sie den folgenden Hinweis. Er ist Voraussetzung, um das
          Assessment zu starten.
        </p>

        {/* Sichtbarer Disclaimer-Text direkt über der Checkbox */}
        <div style={{
          background: '#F7F8FA', border: '1px solid #E7E9EF', borderRadius: 10,
          padding: '16px 18px', color: '#3A4252', fontSize: 14, lineHeight: 1.6,
          marginBottom: 18,
        }}>
          {disclaimer.text}
        </div>

        <label style={{
          display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer',
          fontSize: 14, color: '#101623', lineHeight: 1.5,
        }}>
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ marginTop: 2, width: 16, height: 16, flexShrink: 0, cursor: 'pointer' }}
          />
          <span>Ich habe den Hinweis gelesen und bestätige ihn.</span>
        </label>

        {error && (
          <p style={{ color: 'var(--crit-600, #C0342B)', fontSize: 13, margin: '14px 0 0' }}>
            {error}
          </p>
        )}

        <div style={{ marginTop: 24 }}>
          <Button
            size="md"
            disabled={!checked || submitting}
            onClick={handleConfirm}
          >
            {submitting ? 'Wird bestätigt …' : 'Bestätigen und starten →'}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default SelfAssessmentDisclaimerGate;
